import baseService from './baseService';

export function getSkills(params) {
  return baseService.get(`/skills/${params}`);
}
